export const translations = {
  buscar: {
    pt: 'Buscar',
    en: 'Search',
    de: 'Suche',
    es: 'Búsqueda',
  },
};